import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { LogOut, Loader2 } from 'lucide-react';

interface LogoutConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
}

const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({ open, onOpenChange, onConfirm }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      // Show loader for 2 seconds before logging out
      await new Promise((resolve) => setTimeout(resolve, 2000));
      await onConfirm();
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={isLoading ? undefined : onOpenChange}>
      <DialogContent id="logout_dialog_content" className="max-w-md">
        <DialogHeader>
          <DialogTitle id="logout_dialog_title" className="flex items-center gap-2">
            <LogOut className="h-5 w-5 text-destructive" />
            Confirm Logout
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 text-center">
          <p id="logout_dialog_message">Are you sure you want to log out?</p>
        </div>
        <div className="flex justify-end gap-2">
          <Button id="logout_dialog_cancel_btn" variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button id="logout_dialog_confirm_btn" variant="destructive" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Logging out...
              </>
            ) : (
              "Logout"
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
